<template>
  <div class="h-fit bg-blue-400 flex flex-col items-center p-8 pb-28">
    <div
      class="text-white w-full max-w-2xl text-center"
      data-aos="slide-up"
      data-aos-duration="1000"
    >
      <h2
        class="text-lg font-bold tracking-wide mb-4"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        DOA PENGANTIN
      </h2>

      <p
        class="text-md mb-2 font-semibold"
        data-aos="fade-up"
        data-aos-delay="400"
      >
        بَارَكَ اللَّهُ لَكَ وَبَارَكَ عَلَيْكَ وَجَمَعَ بَيْنَكُمَا فِي خَيْرٍ
      </p>

      <p class="text-sm italic mb-4" data-aos="fade-up" data-aos-delay="600">
        Baarokallahu laka wa baaroka 'alaika wa jama'a bainakuma fii khoir
      </p>
      <p class="text-sm mb-8" data-aos="fade-up" data-aos-delay="800">
        "Semoga Allah memberi berkah kepadamu dan atasmu serta menghimpunkan
        kamu berdua (pengantin laki-laki dan perempuan) dalam kebaikan."
      </p>

      <p class="text-sm mb-8" data-aos="fade-up" data-aos-delay="1000">
        Merupakan suatu kehormatan dan kebahagiaan bagi kami sekeluarga apabila
        Bapak/Ibu/Saudara/i berkenan hadir untuk memberikan doa restu kepada
        kedua mempelai. Atas kehadiran serta doa restunya, kami ucapkan terima
        kasih.
      </p>

      <h3
        class="text-xl font-semibold mb-2"
        data-aos="fade-up"
        data-aos-delay="1200"
      >
        Syifa & Hidayat
      </h3>

      <span class="text-xl mb-6" data-aos="fade-up" data-aos-delay="1300"
        >♡</span
      >
    </div>

    <p
      class="mt-6 text-center text-sm text-white"
      data-aos="fade-up"
      data-aos-delay="1400"
    >
      MADE WITH LOVE BY
    </p>
    <div
      class="text-white text-lg font-bold"
      data-aos="fade-up"
      data-aos-delay="1500"
    >
      Kinur
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "WeddingFooter",
});
</script>

<style scoped></style>
